import React from "react";
import { motion } from "framer-motion";
import { AppWrap } from "../../wrapper";

import { images } from "../../constants";
import "./Header.scss";

const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
};

const Header = () => {
  return (
       <div className="app__header app__flex">
         <motion.div
           whileInView={{ x: [-100, 0], opacity: [0, 1] }}
           transition={{ duration: 0.5 }}
           className="app__header-info"
         >
           <div className="app__header-badge">
             <div className="badge-cmp app__flex">
               {/* <span>👋</span> */}
               <div style={{ marginLeft: 10 }}>
                 <h1 className="head-text">
                   Hi, I’m Collins — Software Engineer Building Scalable Product Platforms.
                 </h1>
                 <p className="p-text" style={{ marginTop: 10 }}>
                   I architect and deliver modern React/TypeScript systems for enterprise and regulated environments.
                 </p>
               </div>
             </div>
           </div>
         </motion.div>
   
         <motion.div
           whileInView={{ opacity: [0, 1] }}
           transition={{ duration: 0.5, delayChildren: 0.5 }}
           className="app__header-img"
         >
           <img src={images.latest_heroPic} alt="profile_bg" />
           <motion.img
             whileInView={{ scale: [0, 1] }}
             transition={{ duration: 1, ease: "easeInOut" }}
             src={images.circle}
             alt="profile_circle"
             className="overlay_circle"
           />
         </motion.div>
   
         <motion.div
           variants={scaleVariants}
           whileInView={scaleVariants.whileInView}
           className="app__header-circles"
         >
           {[images.react, images.redux, images.node].map((circle, index) => (
             <div className="circle-cmp app__flex" key={`circle-${index}`}>
               <img src={circle} alt="tech_icon" />
             </div>
           ))}
         </motion.div>
       </div>
  );
};

export default AppWrap(Header, "home");
